export default __webpack_public_path__ + "images/0xddf26b42c1d903de8962d3f79a74a501420d5f19.png";